export const SAVE_SIDENAV_SEARCH_TEXT = 'SAVE_SIDENAV_SEARCH_TEXT';
export const SIDENAV_SUB_MENU = 'SIDENAV_SUB_MENU';

export function saveSidenavSearchText(searchText) {
  return {
    type: SAVE_SIDENAV_SEARCH_TEXT,
    searchText,
  };
}

export function sidenavIsSubMenu(isSubMenu) {
  return {
    type: SIDENAV_SUB_MENU,
    isSubMenu,
  };
}
